export interface ApiLogItem {
  url: string;
  startTime: number;
  endTime?: number;
  duration?: number;
}

if (process.client) {
  const pathname = window.location.pathname || '';
  const pageType =
    pathname === '/'
      ? 1
      : pathname.includes('/goods-list/')
        ? 2
        : pathname.includes('/goods-detail/')
          ? 3
          : 0;
  if (pageType !== 0) {
    window.__lcpApiLogs__ = [];
    window.__isLcpApiLogEnabled__ = true;
  }
}

export function getLcpApiLogs(lcpTime: number): ApiLogItem[] {
  if (!window.__lcpApiLogs__) return [];
  return window.__lcpApiLogs__.filter((log) => log.endTime !== undefined && log.endTime <= lcpTime);
}

export function clearLcpApiLogs(): void {
  if (window.__lcpApiLogs__) {
    window.__lcpApiLogs__ = [];
  }
}

export function disableLcpApiLogs(): void {
  window.__isLcpApiLogEnabled__ = false;
}
